import { MasterHelper } from '../../utilities';
import { FilterViewModel } from '../regulation';

export class ImpactAssessmentMasterFilter {
    fromDate: Date;
    toDate: Date;
    legalEntity: FilterViewModel[];
    assessmentTeam: FilterViewModel[];
    reviewTeam: FilterViewModel[];
    implementationTeam: FilterViewModel[];
    assessmentStatus: FilterViewModel[];
    reviewStatus: FilterViewModel[];
    implementationStatus: FilterViewModel[];
    jurisdictions: FilterViewModel[];
    assessors: FilterViewModel[];

    constructor() {
        this.fromDate = MasterHelper.getDate(30);
        this.toDate = MasterHelper.getDate(0);
        this.legalEntity = [];
        this.assessmentTeam = [];
        this.reviewTeam = [];
        this.implementationTeam = [];
        this.assessmentStatus = [];
        this.reviewStatus = [];
        this.implementationStatus = [];
        this.jurisdictions = [];
        this.assessors = [];
    }
}

export class ImpactAssessmentMasterFilterT6{
    fromDate: Date;
    toDate: Date;
    assessmentTeam: FilterViewModel[];
    assessmentStatus: FilterViewModel[];
    jurisdictions: FilterViewModel[];
    assessors: FilterViewModel[];

    constructor(){
        this.fromDate = MasterHelper.getDate(30);
        this.toDate = MasterHelper.getDate(0);
        this.assessmentTeam = [];
        this.assessmentStatus = [];
        this.jurisdictions = [];
        this.assessors = [];
    }
}
